export const DEFAULT_AUTO_SAVE_MODE = "off" as const;

export type AutoSaveMode = "off" | "afterDelay" | "onFocusChange";

export interface PersistedEditorSettings {
	autoSaveMode: AutoSaveMode;
}

function isAutoSaveMode(value: unknown): value is AutoSaveMode {
	return value === "off" || value === "afterDelay" || value === "onFocusChange";
}

/** 永続化されたエディタ設定を検証し、不正な値は既定値へ戻す。 */
export function migratePersistedEditorSettings(value: unknown): PersistedEditorSettings {
	const state = value && typeof value === "object" ? (value as Record<string, unknown>) : {};
	return {
		autoSaveMode: isAutoSaveMode(state.autoSaveMode) ? state.autoSaveMode : DEFAULT_AUTO_SAVE_MODE,
	};
}
